import {
  ATTRIBUTION_HOST_SUFFIX, ATTRIBUTION_PATH_LIMIT, ATTRIBUTION_PROTOCOLS,
  ATTRIBUTION_UTM_FIELDS, ATTRIBUTION_VALUE_LIMIT, SIGNUP_LANDING_DESTINATION, SIGNUP_LANDING_PATHS,
} from '../constants/attribution';
import { SITE_ORIGIN } from '../constants/site';

// Keyed by browser window: SSR never reads or creates a visitor's carrier.
const carriers = new WeakMap();
const browser = () => (typeof window === 'undefined' ? null : window);
const cleanValue = (value) => value.replace(/[\x00-\x1f\x7f]/g, '').trim().slice(0, ATTRIBUTION_VALUE_LIMIT);

export function captureFirstTouch(target = browser()) {
  if (!target?.location) return null;
  if (carriers.has(target)) return carriers.get(target);
  const entry = new URL(target.location.href);
  const carrier = {};
  for (const key of ATTRIBUTION_UTM_FIELDS) {
    const value = cleanValue(entry.searchParams.get(key) || '');
    if (value) carrier[key] = value;
  }
  if (entry.pathname.length <= ATTRIBUTION_PATH_LIMIT) carrier.landing_path = entry.pathname.replace(/\/+$/, '') || '/';
  try {
    const referrer = new URL(target.document?.referrer);
    const host = referrer.hostname.toLowerCase().replace(/\.$/, '');
    if (ATTRIBUTION_PROTOCOLS.includes(referrer.protocol) && host !== ATTRIBUTION_HOST_SUFFIX
      && !host.endsWith(`.${ATTRIBUTION_HOST_SUFFIX}`)) carrier.referrer_host = host;
  } catch { /* Direct entry. */ }
  carrier.captured_at = new Date().toISOString();
  const captured = Object.freeze(carrier);
  carriers.set(target, captured);
  return captured;
}

export function getAttribution(target = browser()) {
  return target ? carriers.get(target) || null : null;
}

export function withAttribution(url, { attribution = getAttribution(), base = SITE_ORIGIN } = {}) {
  const target = new URL(url, base);
  if (!ATTRIBUTION_PROTOCOLS.includes(target.protocol)) return '';
  for (const key of ATTRIBUTION_UTM_FIELDS) {
    if (typeof attribution?.[key] === 'string') target.searchParams.set(key, cleanValue(attribution[key]));
  }
  return String(url).startsWith('/') && !String(url).startsWith('//')
    ? `${target.pathname}${target.search}${target.hash}` : target.href;
}

export function signupDestination(landingPath) {
  return SIGNUP_LANDING_PATHS.includes(landingPath) ? SIGNUP_LANDING_DESTINATION : null;
}
